import React from 'react';
import FlipCard from './FlipCard';
import './Extracurriculars.css';

const Extracurriculars = () => {
  const extracurricularData = [
    {
      title: "Language Skills",
      subtitle: "Conversational Spanish",
      date: "Ongoing",
      location: "",
      front: "Proficient in conversational Spanish, enhancing ability to serve diverse communities in legal practice.",
      back: [
        "Conversational Spanish proficiency",
        "Enables effective communication with Spanish-speaking clients",
        "Valuable skill for immigration law and community outreach",
        "Demonstrates commitment to serving diverse populations"
      ]
    },
    {
      title: "Personal Training Certification",
      subtitle: "National Academy of Sports Medicine",
      date: "Certified",
      location: "",
      front: "Certified personal trainer through NASM, demonstrating dedication to health, wellness, and helping others achieve their goals.",
      back: [
        "Personal Training Certification through National Academy of Sports Medicine (NASM)",
        "Demonstrates commitment to health and wellness",
        "Shows ability to work with diverse individuals to achieve goals",
        "Reflects discipline, motivation, and teaching abilities",
        "Weightlifting expertise and fitness knowledge"
      ]
    },
    {
      title: "International Experience",
      subtitle: "DIS Stockholm Semester",
      date: "Summer 2023",
      location: "Stockholm, Sweden",
      front: "Studied abroad in Stockholm, Sweden, gaining international perspective and cultural awareness essential for global legal practice.",
      back: [
        "DIS Stockholm Semester Summer 2023",
        "International study abroad experience in Sweden",
        "Gained global perspective on political systems and governance",
        "Developed cultural competency and adaptability",
        "Enhanced understanding of international relations and policy"
      ]
    }
  ];

  return (
    <section id="extracurriculars" className="section extracurriculars">
      <h2 className="section-title">Skills & Interests</h2>
      <div className="cards-container">
        {extracurricularData.map((extracurricular, index) => (
          <FlipCard
            key={index}
            title={extracurricular.title}
            subtitle={extracurricular.subtitle}
            date={extracurricular.date}
            location={extracurricular.location}
            front={extracurricular.front}
            back={extracurricular.back}
            animationDelay={index * 180} // Staggered delay: 0ms, 180ms, 360ms, etc.
          />
        ))}
      </div>
    </section>
  );
};

export default Extracurriculars;
